<div style="padding: 15px">
  <div *ngIf="isEnabled">
    <div class="dropzone" fileDragDrop (filesChangeEmiter)="onFileChange($event, 'dropped')">
      <div fxFlex="100" class="text-wrapper" fxLayout="column" fxLayoutAlign="space-evenly center">
        <div fxFlex="50" fxLayout="column" fxLayoutAlign="center center">
          <input type="file" name="file" id="file" (change)="onFileChange($event, 'selected')" multiple />
          <label for="file">
            <div class="textLink" fxFlex fxLayout="row" fxLayoutAlign="space-around start">
              <mat-icon class="file_upload icon_upload"></mat-icon
              ><span class="text_upload">{{ 'uploadDocuments.selectFiles' | translate }}</span>
            </div>
          </label>
        </div>
        <div fxFlex="20" fxLayout="column" fxLayoutAlign="start center">
          <label>O</label>
        </div>
        <div fxFlex="30" fxLayout="column" fxLayoutAlign="start center">
          <label>{{ 'uploadDocuments.dragFiles' | translate }}</label>
        </div>
      </div>
    </div>
  </div>
  <br />
  <hr *ngIf="isEnabled" />
  <!-- <h3 mat-subheader>Files</h3> -->
  <!-- <div class="row fileItem" *ngFor="let f of files; let ind = index">
		<div class="col-sm-12 fileItemIconDiv" (click)="openConfirmDialog(ind);">
			<i class="fa-6x fileItemIcon"></i>
		</div>
		<div class="col-sm-12 fileItemText">
			<span>{{f.name}}</span>
		</div>
	</div> -->

  <div>
    <mat-list>
      <h3 mat-subheader translate>uploadDocuments.files</h3>
      <mat-list-item *ngFor="let file of files; let i = index">
        <div fxFlex fxLayout="row" style="width: 100%">
          <div class="alignItems iconMargin" fxFlex="5">
            <mat-icon mat-list-icon>folder</mat-icon>
          </div>
          <div class="alignItems" fxFlex="85">
            <h4 class="titleFile" mat-line>{{ file.name }}</h4>
          </div>
          <div class="alignItems" fxFlex="10">
            <button class="btnDelete" mat-raised-button color="warn" (click)="deleteFromArray(i, file)">
              {{ 'uploadDocuments.delete' | translate }}
            </button>
          </div>
        </div>
        <mat-divider></mat-divider>
      </mat-list-item>
    </mat-list>
  </div>
</div>
